import type { RouteObject } from 'react-router';
import { PartTypeDetailPage } from './pages/PartTypeDetailPage';

export const PART_TYPE_ROUTES: RouteObject[] = [{ path: 'maintenance/part-types/:id', element: <PartTypeDetailPage /> }];
